import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Result from 'antd/lib/result';
import Avatar from 'antd/lib/avatar';
import { useHistory } from 'react-router-dom';
import { updateProfile } from '../../../../API';
import { config } from '../../../../config';

import './EditProfile.less';

const { REACT_APP_BUILD_ENV } = config;

export const EditProfile = (props) => {
  const { theme } = props;
  const user = JSON.parse(localStorage.getItem('current_user'));
  const { first_name, last_name, email: userEmail, phone_number } = user;
  const displayName = `${first_name[0]}${last_name[0]}`;
  const [firstName, setFirstName] = useState(first_name);
  const [lastName, setLastName] = useState(last_name);
  const [email, setEmail] = useState(userEmail);
  const [phoneNumber, setPhoneNumber] = useState(phone_number);
  const [apiResponse, setApiReponse] = useState('');
  const history = useHistory();

  const submitEditProfile = async () => {
    const response = await updateProfile(REACT_APP_BUILD_ENV, email, firstName, lastName, `+${phoneNumber}`);

    if (response === 200) {
      setApiReponse('success');
    } else {
      setApiReponse(`${response}`);
    }
  };

  return (
    <div className={`edit-profile edit-profile-${theme}`}>
      <div className="edit-profile-card">
        <div className="edit-profile-card__header">
          <div className="edit-profile-card__title">Edit Profile</div>
        </div>
        <div className="edit-profile-card__body">
          {apiResponse ? (
            <div className="edit-profile__result">
              {apiResponse === 'success' ? (
                <Result
                  status="success"
                  title="Hooray! Your profile's successfully updated!"
                  extra={[
                    <Button
                      onClick={() => {
                        setApiReponse('');
                        history.goBack();
                      }}
                      key="reset"
                    >
                      Go to homepage
                    </Button>,
                  ]}
                />
              ) : (
                <Result
                  status="error"
                  title="Oops! There was a problem updating your profile"
                  subTitle={`Error: ${apiResponse}`}
                  extra={[
                    <Button onClick={() => setApiReponse('')} key="retry">
                      Try Again
                    </Button>,
                  ]}
                />
              )}
            </div>
          ) : (
            <>
              <div className="edit-profile-card__profile-photo-section">
                <div className="edit-profile-card__profile-photo">
                  <Avatar
                    size="large"
                    className="edit-profile-img"
                    alt="profile icon"
                    style={{ backgroundColor: user.avatar_color || '#ffffff' }}
                  >
                    {displayName}
                  </Avatar>
                </div>
                <div className="edit-profile-card__profile-photo-info">
                  <div className="edit-profile-card__user-name">{`${first_name} ${last_name}`}</div>
                  <div className="edit-profile-card__change-photo-button">
                    <Button>Change Profile Photo</Button>
                  </div>
                  <div className="edit-profile-card__explain-text">Acceptable formats: jpg, png only</div>
                  <div className="edit-profile-card__explain-text">Max file size: 1mb</div>
                </div>
              </div>
              <Form
                layout="vertical"
                className={`edit-profile__form app-form-${theme}`}
                onFinish={() => {
                  submitEditProfile();
                }}
              >
                <Form.Item
                  name="first name"
                  label="First Name"
                  className="edit-profile__input-wrapper"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your first name',
                    },
                  ]}
                  hasFeedback
                  initialValue={firstName}
                >
                  <Input
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    size="large"
                    className="edit-profile__input"
                  />
                </Form.Item>
                <Form.Item
                  name="last name"
                  label="Last Name"
                  className="edit-profile__input-wrapper"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your last name',
                    },
                  ]}
                  hasFeedback
                  initialValue={lastName}
                >
                  <Input
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    size="large"
                    className="edit-profile__input"
                  />
                </Form.Item>
                <Form.Item
                  name="email"
                  label="E-mail"
                  className="edit-profile__input-wrapper"
                  rules={[
                    {
                      type: 'email',
                      message: 'This is an invalid e-mail',
                    },
                    {
                      required: true,
                      message: 'Please enter your e-mail',
                    },
                  ]}
                  hasFeedback
                  initialValue={email}
                >
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="large"
                    className="edit-profile__input"
                  />
                </Form.Item>
                <Form.Item
                  name="phone"
                  label="Phone Number"
                  className="edit-profile__input-wrapper"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your phone number',
                    },
                  ]}
                >
                  <PhoneInput
                    country="ca"
                    preferredCountries={['ca', 'us']}
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e)}
                    enableSearch
                    disableSearchIcon
                    buttonClass="edit-profile-change-phone__phone-button"
                    dropdownClass="edit-profile-change-phone__phone-dropdown"
                    inputClass="edit-profile-change-phone__input"
                  />
                </Form.Item>
                <div className="edit-profile__button-wrapper">
                  <Button block htmlType="submit" size="large" className="edit-profile__button">
                    <div className="edit-profile__button-text">Save Changes</div>
                  </Button>
                </div>
              </Form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
